import React from 'react'
import classnames from 'classnames'
import styles from './style.styl'

export default function BrandingLink({ size, className, sendUtm = true }) {
  const utmParams = sendUtm ? `utm_source=${encodeURIComponent(location && location.hostname)}` +
                              '&utm_campaign=powered-by-bolt-verb' +
                              '&utm_medium=web-widget' : ''
  const link = (
    <a className={classnames(`${styles.brandingLink} dsg-bold-weight`, className)}
       href={`https://www.drift.com?${utmParams}`}
       target='_blank'>
      Drift
    </a>
  )

  const powerVerb = '⚡'
  return (
    <span className={classnames(styles.BrandingLink, 'color-gray-dark', size, className)}>
      { `We're ${powerVerb} by ` }
      {link}
    </span>
  )
}

BrandingLink.propTypes = {
  size: React.PropTypes.oneOf(['small', 'medium', 'large']),
  className: React.PropTypes.string,
}

BrandingLink.defaultProps = {
  size: 'small',
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/BrandingLink/index.js